import script from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=0ae3a0fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae3a0fc"]])

export default __exports__